import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatTooltip = createCustomElementWrapper('kat-tooltip', 'KatTooltip', {
    'katAriaLabel': 'kat-aria-label',
    'katAriaTrigger': 'kat-aria-trigger',
    'triggerIcon': 'trigger-icon',
    'triggerText': 'trigger-text',
}, {});
